import { useEffect, useState } from "react";
import aStyles from "./appnavbar.module.scss";
import AppNavigationAction from "./AppNavigationAction";
import useAppModernisation from "../../hooks/useAppModernisation";
import { useLocation, useNavigate } from "react-router-dom";
import { useFindInPage } from "../../hooks/FindInPageHooks/useFindInPage";
import useMobileOrientation from "../../hooks/useMobileOrientation";

const HOME = "Home";
const SEARCH = "Search";
const DRUG = "Drugs";
const DRUG_ICON = "Drug";
const ACCOUNT = "Account";

const HOME_ROUTE = "/";
const SEARCH_ROUTE = "/app/searchLanding";
const DRUG_ROUTE = "/app/drugLanding";
const DRUG_OVERVIEW_ROUTE = "/app/drugOverview";
const ACCOUNT_ROUTE = "/app/accountLanding";
const FAVOURITES_ROUTE = "/app/favourites";
const SAVED_SEARCH_ROUTE = "/app/savedSearch";
const ACCOUNT_SUBSCRIPTION_ROUTE = "/app/accountSubscription";
const ABOUT_US_LEGAL_ROUTE = "/app/aboutUsAndLegal";
const SEARCH_RESULTS = "/searchAction";

const determineSelectedRoute = (pathname) => {
  const isSearchSelected =
    pathname?.startsWith(SEARCH_ROUTE) || pathname?.startsWith(SEARCH_RESULTS);

  const isDrugSelected =
    pathname?.startsWith(DRUG_ROUTE) || pathname?.startsWith(DRUG_OVERVIEW_ROUTE);
  const isAccountSelected =
    pathname?.startsWith(ACCOUNT_ROUTE) ||
    pathname?.startsWith(FAVOURITES_ROUTE) ||
    pathname?.startsWith(SAVED_SEARCH_ROUTE) ||
    pathname?.startsWith(ACCOUNT_SUBSCRIPTION_ROUTE) ||
    pathname?.startsWith(ABOUT_US_LEGAL_ROUTE);

  const isHomeSelected = !(isSearchSelected || isDrugSelected || isAccountSelected);

  return {
    isHomeSelected,
    isSearchSelected,
    isDrugSelected,
    isAccountSelected,
  };
};

const AppNavigation = (props) => {
  const navigation = useNavigate();
  const location = useLocation();
  const { isAppMode } = useAppModernisation();
  const findInPage = useFindInPage();
  const { isPortrait } = useMobileOrientation();
  const { pathname } = location;

  const [navigationState, setNavigationState] = useState({
    isHomeSelected: false,
    isSearchSelected: false,
    isDrugSelected: false,
    isAccountSelected: false,
  });

  useEffect(() => {
    setNavigationState((prevState) => ({
      ...prevState,
      ...determineSelectedRoute(pathname),
    }));
  }, [location, navigation]);

  if (isAppMode && !findInPage.isOpen && isPortrait) {
    return (
      <>
        <nav id="appNavigation" role="menu" className={aStyles.AppNavigationContainer}>
          <AppNavigationAction
            title={HOME}
            icon={HOME}
            isSelected={navigationState.isHomeSelected}
            to={HOME_ROUTE}
          />
          <AppNavigationAction
            title={SEARCH}
            icon={SEARCH}
            isSelected={navigationState.isSearchSelected}
            to={SEARCH_ROUTE}
          />
          <AppNavigationAction
            title={DRUG}
            icon={DRUG_ICON}
            isSelected={navigationState.isDrugSelected}
            to={DRUG_ROUTE}
          />
          <AppNavigationAction
            title={ACCOUNT}
            icon={ACCOUNT}
            isSelected={navigationState.isAccountSelected}
            to={ACCOUNT_ROUTE}
          />
        </nav>
      </>
    );
  }

  return <></>;
};

export default AppNavigation;
